import * as React from 'react';
import * as styles from './manRoundIcon.css';

import { Man } from '../icons';

export function ManRoundIcon() {
  return(
    <div className={styles['round-icon']}>
      <Man />
    </div>
  );
}
